import React from 'lib/react';
import { EVGrid, EVSkeleton } from 'lib/components';
import StatefarmDashboardLoaderStyles from './StatefarmDashboardLoaderStyles';

export default function StatefarmDashboardLoader() {
  const classes = StatefarmDashboardLoaderStyles();
  const rowIds = ['row-1', 'row-2', 'row-3', 'row-4', 'row-5', 'row-6', 'row-7', 'row-8'];

  return (
    <EVGrid container item direction="column" spacing={1}>
      {/* Table Header */}
      <EVGrid container item className={classes.tableHeader}>
        <EVGrid item xs={2}>
          <EVSkeleton className={classes.headerCell} animation="wave" variant="rect" />
        </EVGrid>
        <EVGrid item xs={2}>
          <EVSkeleton className={classes.headerCell} animation="wave" variant="rect" />
        </EVGrid>
        <EVGrid item xs={2}>
          <EVSkeleton className={classes.headerCell} animation="wave" variant="rect" />
        </EVGrid>
        <EVGrid item xs={2}>
          <EVSkeleton className={classes.headerCell} animation="wave" variant="rect" />
        </EVGrid>
        <EVGrid item xs={2}>
          <EVSkeleton className={classes.headerCell} animation="wave" variant="rect" />
        </EVGrid>
        <EVGrid item xs={2}>
          <EVSkeleton className={classes.headerCell} animation="wave" variant="rect" />
        </EVGrid>
      </EVGrid>

      {rowIds.map((rowId) => (
        <EVGrid key={rowId} container item className={classes.tableRow}>
          <EVGrid item xs={2}>
            <EVSkeleton className={classes.cell} animation="wave" variant="rect" />
          </EVGrid>
          <EVGrid item xs={2}>
            <EVSkeleton className={classes.cell} animation="wave" variant="rect" />
          </EVGrid>
          <EVGrid item xs={2}>
            <EVSkeleton className={classes.cell} animation="wave" variant="rect" />
          </EVGrid>
          <EVGrid item xs={2}>
            <EVSkeleton className={classes.cell} animation="wave" variant="rect" />
          </EVGrid>
          <EVGrid item xs={2}>
            <EVSkeleton className={classes.cell} animation="wave" variant="rect" />
          </EVGrid>
          <EVGrid item xs={2}>
            <EVSkeleton className={classes.cell} animation="wave" variant="rect" />
          </EVGrid>
        </EVGrid>
      ))}
    </EVGrid>
  );
}
